var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "init_page" }, [
    _c("div", { staticClass: "init_page_panle" }, [
      _vm.hello < 2
        ? _c(
            "div",
            {
              staticClass: "hello",
              class: [_vm.hello < 1 ? "slide-in-fwd-top" : "slide-out-right"],
              attrs: { id: "hello" },
            },
            [
              _c("div", [
                _c("div", { staticClass: "hello_title" }, [_vm._v("ColaPay")]),
                _c("p", { staticClass: "in-two a-fadeinT" }, [
                  _vm._v("初始化须知"),
                ]),
                _c("p", { staticClass: "init_p" }, [
                  _vm._v("1.您需有用一定的VUE和golang基础"),
                ]),
                _c("p", { staticClass: "init_p" }, [
                  _vm._v("2.请您确认是否已经阅读过官方文档"),
                ]),
                _c("p", { staticClass: "init_p" }, [
                  _vm._v("3.请您确认是否了解后续的配置流程"),
                ]),
                _c("p", { staticClass: "init_p" }, [
                  _vm._v("注：开发组不为文档中书写过的内容提供无偿服务"),
                ]),
                _c(
                  "p",
                  { staticClass: "init_btn" },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.goDoc } },
                      [_vm._v(" 阅读文档 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.showNext },
                      },
                      [_vm._v(" 我已确认 ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.hello > 0
        ? _c(
            "div",
            {
              staticClass: "form",
              class: [
                _vm.hello > 0 && !_vm.out ? "slide-in-left" : "",
                _vm.out ? "slide-out-right" : "",
              ],
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "100px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "数据库类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { disabled: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.sqlType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sqlType", $$v)
                            },
                            expression: "form.sqlType",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "mysql",
                            attrs: {
                              label: "mysql(目前只支持mysql)",
                              value: "mysql",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "host" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入数据库链接" },
                        model: {
                          value: _vm.form.host,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "host", $$v)
                          },
                          expression: "form.host",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "port" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入数据库端口" },
                        model: {
                          value: _vm.form.port,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "port", $$v)
                          },
                          expression: "form.port",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "userName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入数据库用户名" },
                        model: {
                          value: _vm.form.userName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userName", $$v)
                          },
                          expression: "form.userName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "password" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入数据库密码（没有则为空）",
                        },
                        model: {
                          value: _vm.form.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "password", $$v)
                          },
                          expression: "form.password",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "dbName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入数据库名称" },
                        model: {
                          value: _vm.form.dbName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "dbName", $$v)
                          },
                          expression: "form.dbName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSubmit },
                          },
                          [_vm._v("立即初始化")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }